import { DiscountType } from "../types/receipt";

export enum PAYMENT_STATUS {
  UNBILLED = "unbilled",
  SUCCESS = "success",
  FAILED = "failed",
  CREATED = "created",
  TO_REFUND = "to_refund",
  REFUND_PROCESSED = "refund_processed",
  REFUNDED = "refunded",
  CANCELLED = "cancelled",
}

export enum RECEIPT_TYPE {
  INCLINIC = "INCLINIC",
  EKAPREPAID = "EKAPREPAID",
  REFUND = "REFUND",
  DUE_PAYMENT = "DUE_PAYMENT",
  CREDIT_NOTE = "CREDIT_NOTE",
}

export enum DISCOUNT_TYPE {
  PERCENTAGE = "PERCENTAGE",
  AMOUNT = "AMOUNT",
}

export enum RECEIPT_PAYMENT_MODE_ID {
  CASH = "CASH",
  UPI = "UPI",
  DEBIT_CARD = "DEBIT_CARD",
  GPAY = "GPAY",
  PAYTM = "PAYTM",
  CREDIT_CARD = "CREDIT_CARD",
  OTHER = "OTHER",
  EKA_POSTPAY = "EKA_POSTPAY",
  EKA_PREPAID = "EKA_PREPAID",
  EKA_WALLET = "EKA_WALLET",
}

export enum RECEIPT_PAYMENT_MODE_NAME {
  CASH = "Cash",
  UPI = "UPI",
  DEBIT_CARD = "Debit Card",
  GPAY = "GPay",
  PAYTM = "Paytm",
  CREDIT_CARD = "Credit Card",
  OTHER = "Other",
  EKA_POSTPAY = "Eka Payment",
  EKA_PREPAID = "Eka Prepaid",
}

export enum RECEIPT_STATUS_TYPE {
  PENDING = "PENDING",
  SUCCESS = "SUCCESS",
  FAILED = "FAILED",
}

export enum RECEIPT_FLOW_STATES {
  CREATE_RECEIPT = "create",
  VIEW_SINGLE_RECEIPT = "action",
  VIEW_ALL_RECEIPTS = "all-receipts",
  SEND_PAYMENT_LINK = "send-payment-link",
  SETTLE_DUES = "settle-due",
  EDIT_RECEIPT = "edit",
  NONE = "",
}
